import React from 'react';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';
import {
  Sprout,
  FlaskConical,
  TrendingUp,
  AlertTriangle,
  ShieldCheck,
  FileText
} from 'lucide-react';

export function AgroKpiDashboard() {
  const agroKpis: KpiItem[] = [
    {
      title: 'Dự án áp dụng',
      value: 24,
      suffix: 'Dự án',
      icon: Sprout,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Mở rộng',
      chartColor: 'bg-emerald-500',
      chartData: [20, 22, 21, 23, 24, 24, 24]
    },
    {
      title: 'Lượng pha chế',
      value: 1250,
      suffix: 'Lít',
      icon: FlaskConical,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'up',
      trendValue: 'Tháng này',
      chartColor: 'bg-blue-500',
      chartData: [1000, 1100, 1050, 1200, 1150, 1250, 1250]
    },
    {
      title: 'Cảnh báo tồn kho',
      value: 3,
      suffix: 'Mặt hàng',
      icon: AlertTriangle,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'down',
      trendValue: 'Cần nhập',
      chartColor: 'bg-amber-500',
      chartData: [5, 4, 4, 3, 3, 3, 3]
    },
    {
      title: 'Hiệu suất phục hồi',
      value: 94.5,
      suffix: '%',
      icon: TrendingUp,
      color: 'text-teal-600',
      bg: 'bg-teal-50',
      trend: 'up',
      trendValue: 'Đạt chuẩn',
      chartColor: 'bg-teal-500',
      chartData: [90, 91, 92, 93, 94, 94.5, 94.5]
    },
    {
      title: 'Công thức chuẩn',
      value: 42,
      suffix: 'Công thức',
      icon: FileText,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'neutral',
      trendValue: 'Đã duyệt',
      chartColor: 'bg-indigo-500',
      chartData: [40, 40, 41, 41, 42, 42, 42]
    },
    {
      title: 'An toàn thi công',
      value: 100,
      suffix: '%',
      icon: ShieldCheck,
      color: 'text-violet-600',
      bg: 'bg-violet-50',
      trend: 'up',
      trendValue: 'Tuân thủ',
      chartColor: 'bg-violet-500',
      chartData: [98, 99, 100, 100, 100, 100, 100]
    }
  ];

  return <KpiGrid kpis={agroKpis} />;
}
